export const QUERY_USERS_ACCOUNTS = "QUERY_USERS_ACCOUNTS";
export const QUERY_USERS_ACCOUNT = "QUERY_USERS_ACCOUNT";
export const QUERY_USERS_ACCOUNT_MISSING_FIELDS =
  "QUERY_USERS_ACCOUNT_MISSING_FIELDS";
export const QUERY_USERS_ACTIVITIES = "QUERY_USERS_ACTIVITIES";
export const QUERY_USERS_USER_PROFILE = "QUERY_USERS_USER_PROFILE";
export const QUERY_USERS_MEMBER_PROFILE = "QUERY_USERS_MEMBER_PROFILE";
export const QUERY_USERS_CLIENT = "QUERY_USERS_CLIENT";
export const QUERY_USERS_ACCOUNT_LINK_TOKEN = "QUERY_USERS_ACCOUNT_LINK_TOKEN";
export const QUERY_USERS_ORGANIZATION_USERS = "QUERY_USERS_ORGANIZATION_USERS";
export const QUERY_USERS_ALL_ORGANIZATION_USERS =
  "QUERY_USERS_ALL_ORGANIZATION_USERS";

export const QUERY_USERS_ALL_ORGANIZATION_USERS_LIST_SIZE =
  "QUERY_USERS_ALL_ORGANIZATION_USERS_LIST_SIZE";
export const QUERY_USERS_ORGANIZATION_USER = "QUERY_USERS_ORGANIZATION_USER";
export const QUERY_ACCOUNT_REQUIREMENTS = "QUERY_ACCOUNT_REQUIREMENTS";
export const QUERY_ACCOUNT_REQUIREMENTS_AVAILABLE_CURRENCIES_FOR_COUNTRY =
  "QUERY_ACCOUNT_REQUIREMENTS_AVAILABLE_CURRENCIES_FOR_COUNTRY";
